import type { Maybe, ValueEvent } from '@adornis/base/utilTypes';
import { subscribeBuildifyGlobalSettings, type BuildifyGlobalSettings } from '@adornis/buildify/db/GlobalSettings';
import { css } from '@adornis/chemistry/directives/css';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog';
import { html } from 'lit';
import { buildifyDefaultTiptapExtensions, customParagraph } from '../../../client/theme/buildify/helpers';
import { IconButton } from '../../design-system/client/IconButton';
import { Comment } from '../db/Comment';

export const EditCommentDialog = async (comment: Comment, globalSettingsClassName: string) => {
  const globalSettings = await new Promise<Maybe<BuildifyGlobalSettings>>((res, rej) => {
    subscribeBuildifyGlobalSettings(globalSettingsClassName)({
      colors: 1,
    }).subscribe(settings => {
      if (!settings) return rej('settings not found');
      return res(settings as BuildifyGlobalSettings);
    });
  });
  if (!globalSettings) return [];
  const tiptapExtensions = buildifyDefaultTiptapExtensions(customParagraph('text'), globalSettings, true);

  return XNativeDialog.showPopup<void>({
    content: (resolve, reject, dialogElement) => {
      return html`
        <x-flex ${css({ width: `800px`, padding: '24px' })} space="md">
          <d-h4> Kommentar bearbeiten </d-h4>
          <x-tiptap
            mode="html"
            .extensions=${tiptapExtensions}
            .value=${comment.text}
            @value-picked=${(e: ValueEvent<string>) => {
              comment.text = e.detail.value;
            }}
          ></x-tiptap>
          <x-flex crossaxis-end>
            ${IconButton({
              icon: 'floppy-disk',
              tooltip: 'Speichern',
              onClickHandler: async () => {
                await comment.save();
                XSnackbar.show('Kommentar gespeichert!');
                resolve();
              },
            })}
          </x-flex>
        </x-flex>
      `;
    },
  });
};
